// extracted by extract-css-chunks-webpack-plugin
module.exports = {"sectionContainer":"Classes__sectionContainer___3_LOP"};